import Anxios from "../axios/Axios";
import Security from "../security/Security";

export default class Api extends Anxios {

    constructor(props: any) {
        super(props);
    }

    getInventoryCsvData = async (params: object) => {
        try {
            const res = await this.post("/api/inventory/csv2", params);
            const data = res.data;
            return data;
        } catch (error) {
            console.error(error);
            throw new Security().getErrorMessage(error);
        }
    };

    getSearchAccountData = async (params: string) => {
        try {
            const res = await this.get(`/api/account/lookup/${params}`, {});
            const data = res.data;
            return data;
        } catch (error) {
            console.error(error);
            throw new Security().getErrorMessage(error);
        }
    };
}
